<ng-container *ngIf="appearance === 'overlay'; else labeled">
  <button mat-icon-button
          class="rating-trigger overlay"
          [class.liked]="isLiked"
          [class.hated]="isHated"
          [matMenuTriggerFor]="ratingMenu"
          [disabled]="!track"
          matTooltip="Rate track">
    <mat-icon>{{ buttonIcon }}</mat-icon>
  </button>
</ng-container>

<ng-template #labeled>
  <button mat-raised-button
          color="primary"
          class="rating-trigger-labeled"
          [class.liked]="isLiked"
          [class.hated]="isHated"
          [matMenuTriggerFor]="ratingMenu"
          [disabled]="!track"
          matTooltip="Rate current track">
    <mat-icon>{{ buttonIcon }}</mat-icon>
    Rate
  </button>
</ng-template>

<!-- Every choice is one tap: it saves and closes the menu. Any hate also skips the track. -->
<mat-menu #ratingMenu="matMenu" class="track-rating-menu">
  <div class="rating-panel">
    <div class="rating-grid">
      <button type="button"
              class="rating-choice like"
              [class.selected]="isLiked"
              (click)="like()">
        <mat-icon>thumb_up</mat-icon>
        <span>Like</span>
      </button>
      <button type="button"
              class="rating-choice hate"
              [class.selected]="isHated && currentReason === 'just_dont_like'"
              (click)="hate('just_dont_like')">
        <mat-icon>thumb_down</mat-icon>
        <span>Hate</span>
      </button>
      <button type="button"
              *ngFor="let option of reasons"
              class="rating-choice reason"
              [class.selected]="isHated && currentReason === option.value"
              (click)="hate(option.value)">
        <span>{{ option.label }}</span>
      </button>
    </div>
  </div>
</mat-menu>
